import { createTestIds } from '@duke-hq/lib/createTestId';

export const testIds = createTestIds('apps-admin-web-Courses-CourseTranslationCoverage', [
  'page',
  'summaryLine',
  'languageRow',
  'regenerateFailedButton',
  'downloadCsvButton',
  'errorAlert',
  'emptyState',
  'unitGroup',
  'resourceRow',
  'resourceGap',
  'retryButton',
  'retranslateButton',
  'retranslateScopeButton',
  'attentionCard',
  'attentionGroup',
  'attentionRow',
  'attentionRowRetry',
  'showAllButton',
  'languageTag',
]);
